import * as types from './mutation-types';

export default {
  [types.SET_CONFIGURATION](state, payload) {
    state.nfseConfigurations = payload;
  },
};
